import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractUserRelatedDataService } from '@y42/feature';
import {
  VisualizationDashboardQuery,
  VisualizationDashboardState,
  VisualizationDashboardStore,
} from '../../state/dashboard';

@Injectable({ providedIn: 'root' })
export class VisualizationDashboardUserDataService extends AbstractUserRelatedDataService<VisualizationDashboardState> {
  constructor(
    readonly http: HttpClient,
    readonly store: VisualizationDashboardStore,
    readonly query: VisualizationDashboardQuery,
  ) {
    super({
      http,
      store,
      query,
      URLs: {
        last_used: 'visualization-dashboard-last_used',
        starred: 'visualization-dashboard-starred',
      },
    });
  }
}
